module.exports = __webpack_public_path__ + "img/avatar1.f96ff2ac.png";